import React, { useEffect, useState } from "react";
import Job1 from "../../assets/images/job-ico1.png";
// import Job2 from "../../assets/images/job-ico2.png";
import Job3 from "../../assets/images/job-ico3.png";
import { FREELANCER } from "../../Router/paths";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../config/https";
import { useLoader, useModal } from "../../context/LoaderContext";
import { toast } from "react-toastify";

export default function SubmitProposalComp() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  const [bid, setBid] = useState("");
  const [connects, setConnects] = useState("");
  const [coverLetter, setCoverLetter] = useState("");
  // console.log("state", state);

  useEffect(() => {
    const getConnects = () => {
      startLoader();
      axiosInstance
        .get("/api/payments/current_user/")
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setConnects(Data[0]?.connects);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    if (state?.id) {
      getConnects();
    } else {
      navigate(FREELANCER.dashboard);
    }
    openModal(
      "bidding", //gif url
      "Try Automated Bid Feature!", //title
      "Bid smarter, not harder! Explore our time-saving feature to automate your bids and optimize your freelancing journey." //subtitle
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const helpBid = (id) => {
    startLoader();
    axiosInstance
      .get(`/api/mydata/?job_id=${id}`)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          setCoverLetter(Data.data);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const submitProposal = () => {
    const formData = new FormData();
    formData.append("job_post", state?.id);
    formData.append("bid", bid);
    formData.append("cover_letter", coverLetter);
    startLoader();
    axiosInstance
      .post(`/api/job-proposals/`, formData)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          openModal(
            "thubsUp", //gif url
            "Bid submitted!", //title
            "Success! Your bid has been submitted. Now, sit back and await potential opportunities for your expertise." //subtitle
          );
          // toast.success("proposal submit successfully");
          navigate(FREELANCER.viewProposals);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  return (
    <section className="submit-prosec pc-p-3">
      <div className="container-fluid px-5">
        <div className="primary-heading color-dark">
          <h4>Submit a Proposal</h4>
        </div>
        <div className="primary-box mt-4">
          <div className="primary-heading color-dark">
            <h5 className="mb-5">Proposal settings</h5>
            <p>
              This proposal requires{" "}
              <span className="color-secondary">8 Connects</span>
            </p>
            <p>
              When you submit this proposal, you'll have {connects} Connects
              remaining.
            </p>
          </div>
        </div>
        <div className="job-detail-box primary-box mt-4">
          <div className="row border-bottom align-items-center pb-3">
            <div className="col-lg-9">
              <div className="primary-heading color-dark">
                <h5 className="mb-5">Job details</h5>
                <h6>{state?.job_title}</h6>
                <p className="tag-p">
                  <span>Scope: {state?.scope}</span> Posted{" "}
                  {state?.created_time}
                </p>
                <p>{state?.description}</p>

                {/* <p>The ideal candidate would be:</p>
                <ul className="mb-3">
                  <li>Fluent in English - Quick and responsive</li>
                  <li>Able to communicate in Slack</li>
                  <li>
                    Have the ability to take an example or idea and run with it
                  </li>
                  <li>Eager to understand our industry and target audience</li>
                  <li>Creative and recommend new designs we didn't consider</li>
                </ul>
                <p>
                  Mention the word "academy” at the top of your proposal to be
                  considered.
                </p>
                <a href="javascript:void(0)" className="color-secondary a-link">
                  Less
                </a>
                <a href="javascript:void(0)" className="color-secondary a-link">
                  View job posting
                </a> */}
              </div>
            </div>
            <div className="col-lg-3 border-left">
              <div className="job-specs primary-heading color-dark">
                <div className="job-specs-icon">
                  <img src={Job1} alt="Job Icon" />
                </div>
                <div className="job-specs-content">
                  <h5>Expert</h5>
                  <p className="text-capitalize">{state?.experience_needed}</p>
                </div>
              </div>
              {/* <div className="job-specs primary-heading color-dark">
                <div className="job-specs-icon">
                  <img src={Job2} alt="Job Icon" />
                </div>
                <div className="job-specs-content">
                          <h5>$10.00 - $50.00</h5>
                          <p>Hourly Range</p>
                      </div>
              </div> */}
              <div className="job-specs primary-heading color-dark">
                <div className="job-specs-icon">
                  <img src={Job3} alt="Job Icon" />
                </div>
                <div className="job-specs-content">
                  <h5>{state?.length} months</h5>
                  <p>Project Length</p>
                </div>
              </div>
            </div>
          </div>
          <div className="primary-heading color-dark mt-3">
            <h6>Skills and expertise</h6>
            <p className="tag-p">
              {state?.skills.map((e) => (
                <span className="mr-2">{e.name}</span>
              ))}
              {/* <span>Graphic Design</span>
              <span className="ml-3">Canva</span>
              <span className="ml-3">Social Media Imagery</span> */}
            </p>
          </div>
        </div>
        <div className="job-terms-box primary-box mt-4">
          <div className="primary-heading color-dark">
            <h5 className="mb-3">Terms</h5>
            <div className="terms-bgbox">
              <p>
                See What Other Freelancers Are Bidding On Jobs With Freelancer
                Plus To Get Ahead Of The Competition And Win More Contracts.{" "}
                <Link to="#">Compare Plus</Link>
              </p>
            </div>
            <h6>What is the Rate You'd Like To Bid For This Job?</h6>
            <ul className="list-inline  ml-0">
              {/* <li className="list-inline-item ml-0">
                Your Profile Rate: $3.00/Hr
              </li> */}
              <li className="list-inline-item ml-0">
                Client Budget: ${state?.project_budget}
              </li>
            </ul>
            <div className="terms-rate-box mt-5 border-bottom pb-3">
              <div className="row align-items-end">
                {/* <div className="col-lg-5">
                          <h6>Hourly Rate</h6>
                          <p className="mb-0">Total Amount The Client Will See On Your Proposal</p>
                      </div> */}
                <div className="col-lg-2">
                  <div className="main-form">
                    <input
                      type="number"
                      placeholder="0"
                      className="form-control p-2"
                      value={bid}
                      onChange={(e) => setBid(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <p className="mb-0">$</p>
                </div>
              </div>
            </div>
            <div className="terms-rate-box mt-5">
              <div className="row align-items-end">
                <div className="col-lg-5">
                  <h6>You'll receive</h6>
                  <p className="mb-0">
                    The estimated amount you'll receive after service fees
                  </p>
                </div>
                <div className="col-lg-2">
                  <div className="main-form">
                    <input
                      type="number"
                      placeholder="0"
                      className="form-control p-2"
                      value={bid}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <p className="mb-0">$</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="job-terms-box primary-box mt-4">
          <div className="primary-heading color-dark">
            <h5 className="mb-3">Describe Your Proposal</h5>
            <div className="main-form">
              <div className="form-group">
                <textarea
                  className="form-control px-3"
                  rows={10}
                  value={coverLetter}
                  onChange={(e) => setCoverLetter(e.target.value)}
                />
                <button
                  className="primary-btn primary-bg mt-3"
                  onClick={() => helpBid(state?.id)}
                >
                  Help You Bid
                </button>
              </div>
            </div>
          </div>
        </div>
        <ul className="d-flex align-items-center mt-5">
          <li>
            <Link
              // to={FREELANCER.viewProposals}
              className="primary-btn secondary-bg"
              onClick={submitProposal}
            >
              Send For 8 Connects
            </Link>
          </li>
          <li className="ml-3">
            <Link to={FREELANCER.dashboard} className="a-link color-secondary">
              Cancel
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
}
